import { ReactNode } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'

interface AdminRouteProps {
  children: ReactNode
}

export default function AdminRoute({ children }: AdminRouteProps) {
  const { user, isAdmin, loading, adminLoading } = useAuth()
  const location = useLocation()

  // Wait for BOTH auth and admin loading to complete
  if (loading || adminLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-gray-100">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
          <p className="mt-4 text-gray-600">
            {loading ? 'Checking authentication...' : 'Verifying admin access...'}
          </p>
        </div>
      </div>
    )
  }

  // Only redirect after loading is complete
  if (!user) {
    return <Navigate to="/login" state={{ from: location, message: 'Please log in to continue.' }} replace />
  }

  if (!isAdmin) {
    return <Navigate to="/" state={{ message: 'Access denied — Admins only' }} replace />
  }

  // User is authenticated and is an admin
  return <>{children}</>
}
